import Colors from '@root/joinroot.com/src/utils/colors';
import PropTypes from '@root/vendor/prop-types';

export default function WashingtonDC({ onClick, styles }) {
  return (
    <a
      className={'state-coming-soon'}
      css={styles.stateLink}
      data-state-id={'dc'}
      data-testid={'dc'}
      href={'#'}
      onClick={(e) => onClick(e, {
        id: 'dc',
        name: 'Washington D.C.',
        status: 'soon',
        page: false,
      })}
      tabIndex={'-1'}
    >
      <g
        className={'state'}
        css={styles.state}
      >
        <path
          d={'M801.8,253.8 l-1.1-1.6 -1-0.8 1.1-1.6 2.2,1.5z'}
        />
        <title>Washington D.C.</title>
        <circle
          cx={'801.3'}
          cy={'251.8'}

          opacity={'1'}
          r={'5'}
          stroke={`${Colors.white()}`}
          strokeWidth={'1.5'}
        />
      </g>
      <text
        css={[styles.stateLabel, styles.stateLabelWithLine]}
        transform={'translate(858.73 256.6)'}
      >
        DC
      </text>
      <path
        css={styles.labelLine}
        d={'M854.5,250.5h-53'}
        transform={'translate(0, -0.4)'}
      />
    </a>
  );
}

WashingtonDC.propTypes = {
  onClick: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
};
